import { ScnMainData } from "../scn/app";

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function getAgencyIdsFromDataContext(dataContext: ScnMainData | null): string[] {
  if (dataContext?.agency_id) {
    return [dataContext.agency_id];
  }
  if (dataContext?.agenciesOfRg4?.length) {
    return dataContext.agenciesOfRg4.map(agency => agency.agency_id);
  }
  // RG2 global view: agencies list with `id` field
  if (dataContext?.agencies?.length) {
    return dataContext.agencies.map(agency => agency.id);
  }
  return [];
}